export default __webpack_public_path__ + "static/media/create.4c863cb6.mp4";